import { AffiliatePayment, ConsumableType, ProductItemType } from "@/types";

const PLAN_LABELS: Record<number, string> = {
  1: "monthly",
  3: "quarterly",
  6: "half-year",
  12: "yearly",
};

export function getAffiliatePaymentDescription(
  payment: AffiliatePayment,
): string {
  if (payment.type === "muse-approval") {
    return `Woman joined`;
  }

  //The following code is restricted to users with the alpha role only.
  const item = payment.order?.products?.[0]?.product?.items?.[0];

  if (!item) {
    return "Unknown payment";
  }

  if (item.itemType === ProductItemType.Consumable) {
    if (item.item.type === ConsumableType.HotEvent) {
      return `Man hot event`;
    }
    return "Unknown consumable type";
  }

  if (item.itemType === ProductItemType.Plan) {
    const isOneTime = item.item.isOneTime;
    const months = item.item.duration?.months;
    const days = item.item.duration?.days;

    if (days != null && isOneTime) {
      return `Man one time payment - ${days} days`;
    }
    const label = months != null ? PLAN_LABELS[months] : undefined;
    if (label) {
      return `Man ${label} payment`;
    }
    return "Unknown plan duration";
  }

  return "Unknown payment type";
}
